// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1rA17","large":"styles_large__2qawW"};